import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const r = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", "/portal");
        await refresh();
        navigate("/portal", { replace: true, state: { user: r.data.user } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
      <div className="text-[#0A1128]/60 font-serif italic">…</div>
    </div>
  );
}
